import React from 'react'
import { IEditorWidget } from '../EditorService'

export const mapWidget: IEditorWidget = {
  id: 'map',
  name: 'Map',
  description: 'Show an interactive map with pins',
  image: require('./img/map.png'),
  renderer() {
    return <iframe
      style={{ width: '100%', height: '100%' }}
      frameBorder="0"
      scrolling="no"
      marginHeight={0}
      marginWidth={0}
      src="https://www.openstreetmap.org/export/embed.html?bbox=-0.8466339111328125%2C51.22193759776983%2C0.49919128417968756%2C51.7559402747204&amp;layer=mapnik"
    />
  },
}
